/*
 * Site menu module for dealing with the menu popouts
*/

rs.module("controls/navigation/sitemenu-popout",

    [
        "controls/navigation/sitemenu",
        "common/perfect-scrollbar",
        "ui/framework/client-templates",
        "ui/framework/userstate-manager"
    ],

    function (siteMenu, perfectScrollbar, clientTemplates, userStateManager) {

        var _popoutToDockKey;

        var _menu;
        var _sidebar;
        var _dockToggle;
        var _popout;
        
        var _popoutContainers = {};

        var _jsSelectors;
        var _cssClasses;
        var _clientTemplateKeys;
        var _popoutDockedStateKey;

        const _hoverOutDelay = 600;

        //
        // Initialize the popout functionality of the menu
        //
        function initialize(jsSelectors, cssClasses, clientTemplateKeys, userStateKeys, popoutToDockKey) {

            _popoutToDockKey = popoutToDockKey;

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _clientTemplateKeys = clientTemplateKeys;
            _popoutDockedStateKey = userStateKeys.popoutDocked;

            _menu = $.js(jsSelectors.menu);
            _sidebar = _menu.js(jsSelectors.sidebar);
            _dockToggle = _menu.js(jsSelectors.dockToggle, { required: false });
            _popout = $.js(jsSelectors.popout);

            // We need to initialize our internal state for any popouts sent down by the server
            _initializePopoutContainersSentByServer();

            // If we are docked we have to make sure we either got sent down the content for it by the server,
            // or we start to fetch it right away.
            if (_isMenuMarkedAsDocked() && !_getDockedPopoutContainer().exists()) {
                _markPopoutContainerDocked(_getPopoutContainer(_getDockedPopoutKey()), true);
            }

            // Find all the popout links
            var popoutLinks = _sidebar.find("a[data-for]");

            // Watch for hovering on our popout items. Our popout links are marked with data-for of the popout key they are for
            popoutLinks.hoverIntent({
                handlerOver: function (event) { _onMenuLinkHoverOver($(event.currentTarget)); },
                handlerOut: function (event) { _onMenuLinkHoverOut($(event.currentTarget)); },
                hoverOutDelay: _hoverOutDelay
            });

            // Listen for clicks on the dock toggle. 
            _dockToggle.on("click", _togglePopoutDocked);

            // Start listening to the menu for when to update them in the future
            siteMenu.updateScrollbars(_onScrollbarsNeedUpdated);
        }

        //
        //  Prepare our internal state for any popouts sent down by the server
        //
        function _initializePopoutContainersSentByServer() {

            _popout.find(`[data-for]`).each(function () {

                var popoutKey = $(this).data("for");

                _getPopoutContainer(popoutKey);
            });
        }

        //
        // A menu item with a popout is being hovered over
        //
        function _onMenuLinkHoverOver(menuLink) {

            // Get the popout container element associated with the given menu link, 
            // and the container that is already currently open (if any)
            var container = _getPopoutContainer(_getMenuLinkPopoutKey(menuLink));

            // If this one is docked, then we don't do anything.  A docked popout counts just as any other background content would.
            if (_isPopoutDocked(container)) {
                menuLink.hoverClear();
                return;
            }

            var previous = _getHoveredPopoutContainer();

            // It could be that the mouse has just left 'previous' popout (even if it is the same
            // as 'container' that's fine).  We don't want to listen for it to hoverOut anymore, the hoverOut
            // that will matter now will be our own.
            if (previous.exists()) {
                previous.hoverClear();
            }

            // If this container is the same as the one already open, nothing to do it's already open.
            if (container.is(previous)) {
                return;
            }

            // Mark it hovered
            _markPopoutContainerHovered(container);

            // If there was a previous one already open, mark it closed
            if (previous.exists()) {

                _markPopoutContainerUnhovered(previous);

                // We also don't want to listen for a hoverOut on the previous menu link, because we just manually closed the container for it.  It could
                // be that the hoverOut is still pending (due to the hoverOutDelay), but we just clear that out now.
                _getPopoutContainerState(previous).menuLink.hoverClear();
            }
        }

        //
        // Mouse is leaving a menu item that had been hovered over
        //
        function _onMenuLinkHoverOut(menuLink) {

            // Get the container element associated with the given menu link
            var container = _getPopoutContainer(_getMenuLinkPopoutKey(menuLink));

            // Mark this container as now being closed
            _markPopoutContainerUnhovered(container);
        }

        //
        // User is entering the popout area with the mouse
        //
        function _onPopoutHoverOver() {

            var entering = $(this);

            // If this one is docked or in the process of undocking, then we don't do anything.  A docked popout counts just as any other background content would.
            if (_isPopoutDocked(entering) || _isPopoutUndocking(entering)) {
                entering.hoverClear();
                return;
            }

            var previous = _getHoveredPopoutContainer();

            // Mark the one we are entering as now hovered
            _markPopoutContainerHovered(entering);

            // If there was a previous one already open
            if (previous.exists()) {

                // We are replacing the previously hovered one, mark it unhovered
                if (!entering.is(previous)) {
                    _markPopoutContainerUnhovered(previous);
                    previous.hoverClear();
                }

                // When we start hovering over the popout itself, we don't want to listen anymore for hoverOut on the menu item
                // that triggered it.  Now the dismissing hoverOut we'll be coming from the popout itself.
                _getPopoutContainerState(previous).menuLink.hoverClear();
           }
        }

        //
        // User is leaving the popout area with the mouse
        //
        function _onPopoutHoverOut() {

            var container = _getHoveredPopoutContainer();

            // Mark it as closed
            _markPopoutContainerUnhovered(container);
        }

        //
        // Gets or creates a div that holds the given container
        //
        function _getPopoutContainer(popoutKey) {

            // First find the menu link and its item that is responsible for showing this popout
            var menuLink = _sidebar.find(`[data-for="${popoutKey}"]`);
            var menuItem = _getMenuItemOfLink(menuLink);

            // Then look in our cache for the actual container element
            var container = _popoutContainers[popoutKey];

            if (!container) {

                // See if the container is already present in the DOM.  To not be in our _popoutContainers list, but be in the DOM, means
                // it was already there in the HTML response from the server.
                container = _popout.find(`[data-for="${popoutKey}"]`);

                // If it wasn't already there create a new one from the template
                if (!container.exists()) {
                    container = $(clientTemplates.render(_clientTemplateKeys.popout, { popoutKey: popoutKey }));

                    // Add it to the DOM 
                    _popout.append(container);

                    // Start loading the content
                    _loadPopoutContainerContent(container, menuLink.data("ajax"));
                }

                // This hover in\out is for popouts that are just hovered, and not docked.  When they are just hovered
                // as soon as the mouse enters them we need to consider the user committed to it, as a mouse being over
                // a hovered popout should make sure that popout doesn't dismiss.
                container.hoverIntent({
                    handlerOver: _onPopoutHoverOver,
                    handlerOut: _onPopoutHoverOut,
                    hoverOverInterval: 0,
                    hoverOverTravelAllowance: Number.MAX_VALUE,
                    hoverOutDelay: _hoverOutDelay
                });

                // Save it to our list and create the initial state storage
                _popoutContainers[popoutKey] = container;
                var state = _getPopoutContainerState(container);

                // associate it with its original link element and menu item
                state.menuLink = menuLink;
                state.menuItem = menuItem;

                // Initialize it's scrollbars
                state.scrollbars = perfectScrollbar.createInstance(container.js(_jsSelectors.popoutScrollbox), {

                    suppressScrollX: true,

                    // Having issues where the scrollbars think the content is too long when it isn't.. need to figure this out, but for now
                    // this fixes it.
                    scrollYMarginOffset: 8
                });
            }

            return container;
        }

       //
       // Gets the popout key given menu link element
       //
       function _getMenuLinkPopoutKey(menuLink) {
           var popoutKey = menuLink.data("for");

           if (!popoutKey) {
               console.log(menuLink);
               throw new Error("No popout key was found for the menu link.");
            }

            return popoutKey;
        }

       //
       // Gets the menu item element that contains the given menu link element
       //
       function _getMenuItemOfLink(menuLink) {
            var menuItem = menuLink.parent("li");

            if (!menuItem.exists()) {
               console.log(menuLink);
               throw new Error("Could not find containing menu item for the menu link.");
            }

            return menuItem;
        }

        //
        // Gets the container that is currently docked (if any)
        //
        function _getDockedPopoutContainer() {
            return _popout.find("." + _cssClasses.docked);
        }

        //
        // Gets the container that is currently hovered (if any)
        //
        function _getHoveredPopoutContainer() {
            return _popout.find("." + _cssClasses.hovered);
        }

        //
        // Indiciates if the specified popout container is the docked container
        //
        function _isPopoutDocked(container) {
            return container.data("for") === _getDockedPopoutKey();
        }

        //
        // Indiciates if the specified popout container is currently being undocked
        //
        function _isPopoutUndocking(container) {
            return _getPopoutContainerState(container).hasOwnProperty("Undocking");
        }

        //
        // Gets the state object associated with the given container
        //
        function _getPopoutContainerState(container) {
            var state = container.data("state");

            if (!state) {
                state = {};
                container.data("state", state);
            }

            return state;
        }

        //
        // Load the content of the given container
        // 
        function _loadPopoutContainerContent(container, ajaxUrl) {

            $.get(
                ajaxUrl,

                { },

                function (popoutContent) {
                    container.js(_jsSelectors.popoutContent).html(popoutContent);
                }
            );
        }

        //
        // Mark the given container as hovered with the appropriate css classes.  Ensures the
        // popout is marked open as well.
        //
        function _markPopoutContainerHovered(container) {

            // The container gets marked as hovered
            container.addClass(_cssClasses.hovered);

            // Scroll the content to the top each time a popout is opened
            container.js(_jsSelectors.popoutScrollbox).scrollTop(0);

            // Since we have an visible container, the popout needs to be open.  We also mark the popout as hovered
            _popout.addClass(_cssClasses.open);
            _popout.addClass(_cssClasses.hovered);

            // Optional: we can mark the menu item as hovered too anytime the mouse is over the popout container.  At first I
            // thought I liked it but then it started to seem offputting.
            var menuItem = _getPopoutContainerState(container).menuItem;
            menuItem.addClass(_cssClasses.hovered);
        }

        //
        // Mark the given container as not being hovered with the appropriate css classes.  If there are no other
        // containers visible (we aren't being replaced with a new open one, and nothing is docked), close the popout as well.
        //
        function _markPopoutContainerUnhovered(container) {

            var menuItem = _getPopoutContainerState(container).menuItem;

            container.removeClass(_cssClasses.hovered);
            menuItem.removeClass(_cssClasses.hovered);

            if (!_getHoveredPopoutContainer().exists()) {

                _popout.removeClass(_cssClasses.hovered);

                if (!_isMenuMarkedAsDocked()) {
                    _popout.removeClass(_cssClasses.open);
                }
            }
        }

        //
        // Toggle the state of popout for the current section key as being docked or not.
        //
        function _togglePopoutDocked() {

            if (!$(this).hasClass("_disabled")) {
                // Get the current section container
                var current = _getPopoutContainer(_popoutToDockKey);
                if (!current.exists()) {
                    throw new Error(`No popout was found for key ${_popoutToDockKey} while trying to toggle the docked state.`);
                }

                // If already docked, we are now undocking.
                var isDocking = !(_popout.hasClass(_cssClasses.docked));

                // Toggle the title (tool tip) for Dock/Undock
                _dockToggle.attr("title", isDocking ? "Undock" : "Dock");

                // If we are not docking,  give a bit of feedback delay to let the main content slide back first
                var cssHint = !isDocking ? "delay-close" : null;

                // Get the state of the container
                var containerState = _getPopoutContainerState(current);

                // If we are undocking, we want to suspend hover functionality on the popout that is undocking
                // Because of the placement of the dock toggle, the tendency is for the user to move the mouse into the collapsing popout
                // This causes the popout to jump back open, which is disorienting to the user.
                // To alleviate this, we will temporarily set the state of the container so hover functionality will be suspended until it is fully collapsed
                if (!isDocking) {

                    // set container state for undocking (this will cause hover functionality to be suspended)
                    containerState.Undocking = true;

                    // We are waiting .6s to remove the undocking state and re-enable hover as that is the css transition duration of the collapse
                    setTimeout(function () {
                        delete containerState.Undocking;
                    }, 600);
                }

                // The menu and popout have to be marked docked and open (or not)
                _menu.toggleClass(_cssClasses.docked, isDocking);
                _popout.toggleClass(_cssClasses.open, isDocking);
                _popout.toggleClass(_cssClasses.docked, isDocking);

                // Change the state of the popout container
                _markPopoutContainerDocked(current, isDocking, cssHint);

                // When it is docked, or undocked, either way its no longer considered hovered and we can stop listening for the hover out
                _markPopoutContainerUnhovered(current);
                current.hoverClear();
                containerState.menuLink.hoverClear();

                // Persist the state
                userStateManager.persist(_popoutDockedStateKey, isDocking);
            }
        }

        //
        // Mark the given container as either docked or not
        //
        function _markPopoutContainerDocked(container, docked, cssHint) {

            var menuItem = _getPopoutContainerState(container).menuItem;

            // The container and associated menu link get marked as docked (or not)
            container.toggleClass(_cssClasses.docked, docked);
            menuItem.toggleClass(_cssClasses.docked, docked);

            // Regardless of being docked or not, its not going to be hovered now.  It's either going to be undocking in which case its
            // sliding closed, or its becoming docked in which case its not hovered, its docked.
            container.removeClass(_cssClasses.hovered);
            menuItem.removeClass(_cssClasses.hovered);

            // Clear the hints from the containers to start fresh
            _popout.find(`[data-for]`).removeAttr("data-hint");

            // Set the css hint we need to style off of
            if (cssHint) {
                container.attr("data-hint", cssHint);
            }
        }

        //
        // Indicates if the menu is currently supposed to be popped out
        //
        function _isMenuMarkedAsDocked() {
            return _menu.hasClass(_cssClasses.docked);
        }

        //
        // Gets the popoutKey for the currently docked popout, or null if none
        //
        function _getDockedPopoutKey() {
            if (!_isMenuMarkedAsDocked()) {
                return null;
            }

            var dockedMenuLink = _sidebar.find("." + _cssClasses.docked);
            var dockedPopoutKey = dockedMenuLink.find("a[data-for]").data("for");

            return dockedPopoutKey;
        }

        //
        // Update all the scrollbars in response to the menu telling us we need to
        //
        function _onScrollbarsNeedUpdated() {

            for (var container of _.values(_popoutContainers)) {

                var state = _getPopoutContainerState(container);

                state.scrollbars.update();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);